// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__17JfR","preview":"UserPhotoPost_preview__1c1eA"};